import useAppDispatch from 'common-js/hooks/useAppDispatch';
import { openModal } from 'common-js/reducers/modal/actions';
import { useCallback, useMemo } from 'react';

interface UseTransferToOrganizationItemProps {
  onSuccess?: () => void;
}

const useTransferToOrganizationItem = ({ onSuccess }: UseTransferToOrganizationItemProps) => {
  const dispatch = useAppDispatch();

  const onClick = useCallback(() => {
    dispatch(
      openModal('BulkMoveDevicesModal', {
        onSuccess,
      })
    );
  }, [dispatch, onSuccess]);

  return useMemo(
    () => ({
      label: 'Transfer to organization',
      icon: 'Transfer',
      selectionLimit: 10,
      onClick,
      id: 'devices-bulk-transfertoorganization',
    }),
    [onClick]
  );
};

export default useTransferToOrganizationItem;
